export const loadVConsole = async (
  maxLog: number,
  forceEnable = false
): Promise<any> => {
  if (process.env.NODE_ENV === "development" || forceEnable) {
    const VConsole: any = (await import("vconsole")).default;
    new VConsole({
      disableLogScrolling: false,
      maxLogNumber: maxLog,
    });
  }
};
